import React from 'react'
import PageWrapper from "Pages/@PageWrapper"
import { ADMIN_ROUTES } from "@constants"
import { Grid } from "@mui/material"
import ExportConnectionsTable from "Pages/Admin/ExportConnections/Table"

export default function ExportConnectionsAdminPage() {

	return <PageWrapper
		head={`DS Rentacar | ${ADMIN_ROUTES.TITLE}`}
		title={ADMIN_ROUTES.TITLE}
		subtitle={ADMIN_ROUTES.EXPORT_CONNECTIONS_SUBTITLE}
		isEmpty={false}
	>
		<Grid item>
			<ExportConnectionsTable/>
		</Grid>
	</PageWrapper>
}